import { useTranslation } from "react-i18next";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";

/**
 * Minimal Privacy Policy stub. Content to be reviewed by the site owner.
 */
const Privacy = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo
        title="Privacy Policy"
        description="How Doctors Vietnam collects, uses and protects your personal information when you request medical coordination support."
        path="/privacy"
      />
      <PageHero
        eyebrow="Privacy"
        title="Privacy Policy"
        subtitle="How Doctors Vietnam handles your personal information."
        crumbs={[{ label: t("nav.home"), to: "/" }, { label: "Privacy" }]}
      />
      <section className="vc-container prose prose-slate max-w-3xl py-14 sm:py-16">
        <p><strong>Effective date:</strong> {new Date().toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>
        <p>Doctors Vietnam ("we", "us") is an independent healthcare coordination and patient-support service. This policy explains how we handle information you share with us when requesting support.</p>
        <h2>What we collect</h2>
        <ul>
          <li>Contact details you provide (name, email, phone / WhatsApp).</li>
          <li>Location, service and symptom information you share to receive coordination.</li>
          <li>Correspondence records (form submissions, WhatsApp messages, emails).</li>
        </ul>
        <h2>How we use it</h2>
        <ul>
          <li>To respond to your request and coordinate suitable independent providers.</li>
          <li>To communicate about your enquiry and follow up on care where relevant.</li>
          <li>To improve our service and comply with legal obligations.</li>
        </ul>
        <h2>Who we share it with</h2>
        <p>We only share the minimum information required with the independent doctors, clinics, hospitals or nurses we help you connect with, and with our email delivery provider. We do not sell your data.</p>
        <h2>Storage and retention</h2>
        <p>Data is stored securely and retained only as long as necessary to serve your request and meet legal obligations.</p>
        <h2>Your rights</h2>
        <p>You may request access to, correction of, or deletion of your personal data at any time by emailing <a href="mailto:support@vietclinics.com">support@vietclinics.com</a>.</p>
        <h2>Contact</h2>
        <p>Questions about this policy? Email <a href="mailto:support@vietclinics.com">support@vietclinics.com</a>.</p>
        <p className="text-xs text-[hsl(var(--vc-slate))]">This is a general privacy statement. For a legally binding document tailored to your jurisdiction, please seek legal review.</p>
      </section>
    </>
  );
};

export default Privacy;
